import React from "react";
import UserImg from "./UserImg";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

const Homepage = ({ h }) => {
  return (
    <div>
      {h.map((user, index) => (
        <div key={index} style={{ display: "flex" }}>
          <div
            className="col-sm-2 col-4 mb-3 text-center py-2"
            style={{
              boxSizing: "border-box",
              border: "2px solid black",
              color: "black",
              borderRadius: "10px",
              backgroundColor: "lightgrey",
            }}
          >
            <img
              src={user.profileImage}
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                border: "2px solid white",
              }}
              alt="img"
            />
            <div>
              {user.id}: <strong>{user.username}</strong>
            </div>
            <Button
              style={{ zIndex: "-1 !important", margin: "5px 0" }}
              color="dark"
            >
              <Link to={"/users/" + user.id} style={{ color: "white" }}>
                more
              </Link>
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-around",
              flexWrap: "wrap",
            }}
          >
            <UserImg ids={user.id} />
          </div>
        </div>
      ))}
    </div>
  );
};
export default Homepage;
